import useRequestMutation from 'hooks/client/useMutation';
import type { MutationResponse, RequestTypes } from 'hooks/types/client';

export type UseStartNewSessionParams = {
  urlParams: {
    investigationId: string;
  };
  data: {
    agent_objective: string;
  };
};

type UseStartNewSession = () => Omit<
  MutationResponse<'investigations.extras.startAgentSession'>,
  'mutate' | 'mutateAsync'
> & {
  mutateAsync: (
    data: UseStartNewSessionParams
  ) => Promise<RequestTypes['investigations.extras.startAgentSession']>;
};

const useStartNewSession: UseStartNewSession = () => {
  const { mutateAsync: mutateAsyncBase, ...rest } = useRequestMutation(
    'investigations.extras.startAgentSession',
    {
      invalidate: [['investigations.extras.getAgentSessions']],
    }
  );

  return {
    ...rest,
    mutateAsync: (params) => mutateAsyncBase({ urlParams: params.urlParams, data: params.data }),
  };
};

export default useStartNewSession;
